import React, { Fragment, memo, useCallback, useEffect, useRef, useState } from 'react'
import { Rect, Text, Transformer } from 'react-konva'
import {
    drawTextAlongPath,
    hideToolbar,
    initTextActualSize,
    updateToolbarStyle,
} from '../../context/SelectedVariantContext/helper'

const MIN_TRANSFORM_WIDTH = 50
const MIN_TRANSFORM_HEIGHT = 20

/**
 *
 * @param {*} param
 * @returns
 */
const TextLayer = memo((props) => {
    const { textProps, background, rectRefs, layerId } = props

    const [image, setImage] = useState(null)
    const { hasArc, isLock } = textProps
    const textRef = useRef()

    const _drawTextAlongPath = useCallback(async () => {
        if (textProps.hasArc) {
            const textBlob = await drawTextAlongPath(textProps, background.ratioDefault)
            const img = new window.Image()
            img.crossOrigin = 'Anonymous'
            img.onload = () => {
                const timer = setTimeout(() => {
                    setImage(img)
                }, 1000)
                return () => {
                    clearTimeout(timer)
                }
            }
            img.onerror = () => {
            }
            img.src = textBlob
        }

    }, [textProps.hasArc, background])

    useEffect(() => {
        _drawTextAlongPath()
    }, [_drawTextAlongPath])

    // Register textRef with rectRefs Map for multi-selection
    useEffect(() => {
        if (textRef.current && rectRefs && layerId) {
            rectRefs.current.set(layerId, textRef.current);

            // Cleanup function to remove ref when component unmounts
            return () => {
                rectRefs.current.delete(layerId);
            };
        }
    }, [rectRefs, layerId]);

    useEffect(() => {
        if (textRef.current && rectRefs && layerId) {
            rectRefs.current.set(layerId, textRef.current);
        }
    }, [textRef.current, rectRefs, layerId]);

    return (
        <Fragment>
                <Text
                    {...textProps}
                    ref={textRef}
                    listening={!isLock}
                    draggable={!isLock}
                    fontFamily={textProps.fontFamily}
                    fontWeight={textProps.fontWeight || '400'}
                    fontStyle={textProps.fontStyle || ''}
                    globalCompositeOperation="source-over"
                />
        </Fragment>
    )
})

export default TextLayer
